import { render, staticRenderFns } from "./pricetable_strom.vue?vue&type=template&id=5ccbce76&scoped=true"
import script from "./pricetable_strom.vue?vue&type=script&lang=js"
export * from "./pricetable_strom.vue?vue&type=script&lang=js"
import style0 from "./pricetable_strom.vue?vue&type=style&index=0&id=5ccbce76&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccbce76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ccbce76')) {
      api.createRecord('5ccbce76', component.options)
    } else {
      api.reload('5ccbce76', component.options)
    }
    module.hot.accept("./pricetable_strom.vue?vue&type=template&id=5ccbce76&scoped=true", function () {
      api.rerender('5ccbce76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pricetable_strom.vue"
export default component.exports